export default {"src":"/_next/static/media/piechart_account_age.08e49689.svg","height":250,"width":250};